import Flickity from "flickity";

(function () {
    function initiateSlider(container, autoPlay = false, unbind = true, slides = '.imagemap-slider__item') {
        const sliderContainer = document.querySelector(container);

        if (!sliderContainer) return;

        const allSlides = sliderContainer.querySelectorAll(slides);
        const isSlider = allSlides.length > 1;
        const arrowPrevious = sliderContainer.querySelector('.arrow-prev, .arrow--left');
        const arrowNext = sliderContainer.querySelector('.arrow-next, .arrow--right');

        if (!isSlider) {
            allSlides[0].classList.add('is-selected');
            return;
        }

        const sliderOptions = {
            cellSelector: slides,
            pageDots: false,
            prevNextButtons: false,
            wrapAround: true,
            autoPlay: autoPlay,
            pauseAutoPlayOnHover: true,
            imagesLoaded: true,
        };

        const slider = new Flickity(sliderContainer, sliderOptions);

        if (unbind) {
            slider.unbindDrag();
        }

        if (arrowPrevious) {
            arrowPrevious.addEventListener('click', function () {
                slider.previous();
                return false;
            });
        }

        if (arrowNext) {
            arrowNext.addEventListener('click', function () {
                slider.next();
                return false;
            });
        }

        return slider;
    }

    document.addEventListener('DOMContentLoaded', function () {
        const chairDetailsSlider = initiateSlider('.imagemap-slider__items', false, false);

        if (chairDetailsSlider) {
            document.querySelectorAll(".imagemap-slider__item-num").forEach(function (numElement) {
                numElement.addEventListener('click', function () { return false; });
            });

            const chairImagePoints = document.querySelectorAll(".imagemap-slider__item-point");

            chairDetailsSlider.on('change', function () {
                chairImagePoints.forEach(point => point.classList.remove('selected'));
                chairImagePoints[chairDetailsSlider.selectedIndex].classList.add('selected');
            });

            chairImagePoints.forEach(function (point, index) {
                point.addEventListener('click', function (e) {
                    e.preventDefault();

                    // remove previous selection
                    chairImagePoints.forEach(p => p.classList.remove('selected'));

                    // select this
                    this.classList.add('selected');

                    // update slider - if not already selected
                    const selectedIndex = index; // index is already the correct value
                    chairDetailsSlider.select(selectedIndex); // Assuming select is the method in your Flickity instance
                });
            });

            // Preselect the third image point (index 2)
            chairImagePoints[2].click();
        }
    });
})();
